React = require 'react'
markdown = require './../static/assets/resume.md'
About = React.createClass
  rawMarkup: ->
    __html:
      markdown
  render: ->
    React.createElement("main", null,
      React.createElement("article", {"id": "resume"},
        React.createElement("h2", {"className": "subheader"}, "About"),
        React.createElement("div", {"dangerouslySetInnerHTML": ( @rawMarkup() )})
      )
    )

module.exports = About



/** WEBPACK FOOTER **
 ** ./~/cjsx-loader!./app/components/About.cjsx
 **/